import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { CartaServices } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { CartaCreateFinishSectionPage } from '../carta-create-finish-section/carta-create-finish-section';
import { CartasMenusListPage } from '../../../cartas-menus/cartas-menus-list/cartas-menus-list';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the CartaCreateDishProdSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-create-dish-prod-select',
  templateUrl: 'carta-create-dish-prod-select.html',
})
export class CartaCreateDishProdSelectPage {

  type: any;
  section_index: any;
  section: any;
  carta_uid: string;
  section_name: string = '';
  section_name_ca: string = '';
  section_name_en: string = '';
  section_name_it: string = '';
  section_name_fr: string = '';
  section_name_de: string = '';
  update_state: boolean = false;
  new_section: boolean = false;
  page_index: any;
  carta_name: any;
  new_carta: boolean = false;

  show_alert: boolean = true;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    public analyticsServices: AnalyticsServices) {

    this.update_state = this.navParams.get('update_state');
    this.type = this.navParams.get('type');
    this.carta_uid = this.navParams.get('carta_uid');
    this.section_index = this.navParams.get('section_index');
    this.page_index = this.navParams.get('page_index');
    this.new_section = this.navParams.get('new_section');
    this.section_name = this.navParams.get('section_name') || '';
    this.section_name_ca = this.navParams.get('section_name_ca') || '';
    this.section_name_en = this.navParams.get('section_name_en') || '';
    this.section_name_it = this.navParams.get('section_name_it') || '';
    this.section_name_fr = this.navParams.get('section_name_fr') || '';
    this.section_name_de = this.navParams.get('section_name_de') || '';
    this.carta_name = this.navParams.get('carta_name') || '';
    this.new_carta = this.navParams.get('new_carta');

    this.cartaServices.elements_order_show = false;
    this.cartaServices.carta_dish_prod_array_tmp = [];
    if (this.update_state) {
      if (!this.new_section) {//edit section
        this.cartaServices.carta_dish_prod_array_tmp = Array();
        var section_index_complete = this.navParams.get('section_complete');
        section_index_complete[this.section_index].name_ca = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_ca);
        section_index_complete[this.section_index].name_en = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_en);
        section_index_complete[this.section_index].name_it = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_it);
        section_index_complete[this.section_index].name_de = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_de);
        section_index_complete[this.section_index].name_fr = this.globals.ifVarEmpty(section_index_complete[this.section_index].name_fr);

        var _elements = section_index_complete[this.section_index].elements; //Get the dish section's
        for (let key in _elements) {
          var _array = Array();


          if (_elements[key].type == 'dish') {
            _array.push(_elements[key].uid); //UID
            _array.push(_elements[key].order); //Order
            _array.push('dish');
            _array.push(_elements[key].name_es);
            _array.push(_elements[key].name_ca);
            _array.push(_elements[key].name_en);
            _array.push(_elements[key].name_de);
            _array.push(_elements[key].name_fr);
            _array.push(_elements[key].name_it);

            if (_elements[key].allergens) {
              _array.push(_elements[key].allergens);
            } else {
              _array.push([]);
            }

            _array.push(_elements[key].price);
            _array.push(_elements[key].price_half);
            _array.push(_elements[key].price_tapa);
            _array.push(_elements[key].cost_ration);
            _array.push(_elements[key].image);
            if (_elements[key].description_es != undefined) {
              _array.push(_elements[key].description_es);
            } else {
              _array.push('');
            }
            if (_elements[key].description_ca != undefined) {
              _array.push(_elements[key].description_ca);
            } else {
              _array.push('');
            }
            if (_elements[key].description_en != undefined) {
              _array.push(_elements[key].description_en);
            } else {
              _array.push('');
            }
            if (_elements[key].description_de != undefined) {
              _array.push(_elements[key].description_de);
            } else {
              _array.push('');
            }
            if (_elements[key].description_fr != undefined) {
              _array.push(_elements[key].description_fr);
            } else {
              _array.push('');
            }
            if (_elements[key].description_it != undefined) {
              _array.push(_elements[key].description_it);
            } else {
              _array.push('');
            }
            if (_elements[key].tags != undefined) {
              _array.push(_elements[key].tags);
            } else {
              _array.push([]);
            }
            if (_elements[key].price_takeaway != undefined) {
              _array.push(_elements[key].price_takeaway);
            } else {
              _array.push('');
            }
            if (_elements[key].tk_active == undefined || _elements[key].tk_active) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].featured) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].tk_pickup_day) {
              _array.push(_elements[key].tk_pickup_day);
            } else {
              _array.push('');
            }
            if (_elements[key].tax) {
              _array.push(_elements[key].tax);
            } else {
              _array.push(10);
            }
          } else if (_elements[key].type == 'product') {
            _array.push(_elements[key].uid);
            _array.push(_elements[key].order); //Order
            _array.push('product');
            if (_elements[key].name_es != undefined) {
              _array.push(_elements[key].name_es);
            } else {
              _array.push('');
            }
            if (_elements[key].name_ca != undefined) {
              _array.push(_elements[key].name_ca);
            } else {
              _array.push('');
            }
            if (_elements[key].name_en != undefined) {
              _array.push(_elements[key].name_en);
            } else {
              _array.push('');
            }
            if (_elements[key].name_de != undefined) {
              _array.push(_elements[key].name_de);
            } else {
              _array.push('');
            }
            if (_elements[key].name_fr != undefined) {
              _array.push(_elements[key].name_fr);
            } else {
              _array.push('');
            }
            if (_elements[key].name_it != undefined) {
              _array.push(_elements[key].name_it);
            } else {
              _array.push('');
            }

            if (_elements[key].allergens) {
              _array.push(_elements[key].allergens);
            } else {
              _array.push([]);
            }

            _array.push(_elements[key].price);
            _array.push(_elements[key].price_half);
            _array.push(_elements[key].price_tapa);
            _array.push(_elements[key].cost_ration);
            _array.push(_elements[key].image);
            if (_elements[key].description_es != undefined) {
              _array.push(_elements[key].description_es);
            } else {
              _array.push('');
            }
            if (_elements[key].description_ca != undefined) {
              _array.push(_elements[key].description_ca);
            } else {
              _array.push('');
            }
            if (_elements[key].description_en != undefined) {
              _array.push(_elements[key].description_en);
            } else {
              _array.push('');
            }
            if (_elements[key].description_de != undefined) {
              _array.push(_elements[key].description_de);
            } else {
              _array.push('');
            }
            if (_elements[key].description_fr != undefined) {
              _array.push(_elements[key].description_fr);
            } else {
              _array.push('');
            }
            if (_elements[key].description_it != undefined) {
              _array.push(_elements[key].description_it);
            } else {
              _array.push('');
            }
            if (_elements[key].tags != undefined) {
              _array.push(_elements[key].tags);
            } else {
              _array.push([]);
            }
            if (_elements[key].price_takeaway != undefined) {
              _array.push(_elements[key].price_takeaway);
            } else {
              _array.push('');
            }
            if (_elements[key].tk_active == undefined || _elements[key].tk_active) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].featured) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].tk_pickup_day) {
              _array.push(_elements[key].tk_pickup_day);
            } else {
              _array.push('');
            }
            if (_elements[key].tax) {
              _array.push(_elements[key].tax);
            } else {
              _array.push(10);
            }
          } else {
            _array.push(_elements[key].uid);
            _array.push(_elements[key].order); //Order
            _array.push('combo');
            if (_elements[key].name_es != undefined) {
              _array.push(_elements[key].name_es);
            } else {
              _array.push('');
            }
            if (_elements[key].name_ca != undefined) {
              _array.push(_elements[key].name_ca);
            } else {
              _array.push('');
            }
            if (_elements[key].name_en != undefined) {
              _array.push(_elements[key].name_en);
            } else {
              _array.push('');
            }
            if (_elements[key].name_de != undefined) {
              _array.push(_elements[key].name_de);
            } else {
              _array.push('');
            }
            if (_elements[key].name_fr != undefined) {
              _array.push(_elements[key].name_fr);
            } else {
              _array.push('');
            }
            if (_elements[key].name_it != undefined) {
              _array.push(_elements[key].name_it);
            } else {
              _array.push('');
            }

            if (_elements[key].allergens) {
              _array.push(_elements[key].allergens);
            } else {
              _array.push([]);
            }

            _array.push(_elements[key].price);
            _array.push(_elements[key].price_half);
            _array.push(_elements[key].price_tapa);
            _array.push(_elements[key].cost_ration);
            _array.push(_elements[key].image);
            if (_elements[key].description_es != undefined) {
              _array.push(_elements[key].description_es);
            } else {
              _array.push('');
            }
            if (_elements[key].description_ca != undefined) {
              _array.push(_elements[key].description_ca);
            } else {
              _array.push('');
            }
            if (_elements[key].description_en != undefined) {
              _array.push(_elements[key].description_en);
            } else {
              _array.push('');
            }
            if (_elements[key].description_de != undefined) {
              _array.push(_elements[key].description_de);
            } else {
              _array.push('');
            }
            if (_elements[key].description_fr != undefined) {
              _array.push(_elements[key].description_fr);
            } else {
              _array.push('');
            }
            if (_elements[key].description_it != undefined) {
              _array.push(_elements[key].description_it);
            } else {
              _array.push('');
            }
            if (_elements[key].tags != undefined) {
              _array.push(_elements[key].tags);
            } else {
              _array.push([]);
            }
            if (_elements[key].price_takeaway != undefined) {
              _array.push(_elements[key].price_takeaway);
            } else {
              _array.push('');
            }
            if (_elements[key].tk_active) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].featured) {
              _array.push(true);
            } else {
              _array.push(false);
            }
            if (_elements[key].tk_pickup_day) {
              _array.push(_elements[key].tk_pickup_day);
            } else {
              _array.push('');
            }
            if (_elements[key].tax) {
              _array.push(_elements[key].tax);
            } else {
              _array.push(10);
            }
          }

          this.cartaServices.carta_dish_prod_array_tmp.push(_array);
        }

        this.cartaServices.carta_section_array_complete_tmp = this.cartaServices.edit_section;

      } else {//new section
        //this.cartaServices.carta_dish_prod_array_tmp = Array();

      }
    }
    this.init_carta_dish_prod_array_tmp();
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.cartaServices.afs.collection('cartas').doc(this.carta_uid).delete();
                this.cartaServices.carta_dish_prod_array_tmp = [];
                resolve();
                this.navCtrl.setRoot(CartasMenusListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  openListDetails() {
    this.show_alert = false;
    if (this.getSectionLang() == '') {
      //toast error
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {
      this.updateSection();
      if (this.new_section) {
        this.analyticsServices.trackingExp('crear secció carta', this.globals.tracking_exp['create_section'], '');
      }
      if (!this.update_state) {
        //add section
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'pages': this.cartaServices.carta_page_array_complete_tmp,
          'updated_at': new Date(),
        }).then(() => {
          this.navCtrl.push(CartaCreateFinishSectionPage, {
            update_state: false,
            type: this.type,
            carta_uid: this.carta_uid,
            section_index: this.section_index,
            section_name: this.section_name,
            page_index: this.page_index,
            new_carta: this.new_carta
          });
        });
      } else {
        //update section
        this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'pages': this.cartaServices.carta_tmp.pages,
        }).then(() => {
          this.navCtrl.pop();
        });
      }
    }
  }

  getSectionLang() {
    switch (this.globals.restaurant.lang) {
      case 'es':
        return this.section_name;
      case 'ca':
        return this.section_name_ca;
      case 'en':
        return this.section_name_en;
      case 'it':
        return this.section_name_it;
      case 'fr':
        return this.section_name_fr;
      case 'de':
        return this.section_name_de;
      default:
        return this.section_name; // Por defecto, usar el nombre en español
    }
  }


  deleteSection() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-seccion'),
      message: this.translate.instant('instant-seguro-quieres-eliminarla'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //delete
            delete this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index];
            //reordenar
            var obj_help = {};
            var i = 0;
            for (let item of this.globals.objectToArray(this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections)) {
              obj_help[i] = item;
              i++;
            }
            this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = obj_help;
            this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
              'pages': this.cartaServices.carta_tmp.pages,
            });
            this.cartaServices.edit = false;
            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }

  searchProductsDishesNode(value) {
    this.cartaServices.searchProductsDishesNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }

  rellenarIdiomasVacios() {
    // Detectar el idioma principal
    const mainLang = this.globals.restaurant.lang;
    let mainValue = '';
    switch (mainLang) {
      case 'es': mainValue = this.section_name; break;
      case 'ca': mainValue = this.section_name_ca; break;
      case 'en': mainValue = this.section_name_en; break;
      case 'it': mainValue = this.section_name_it; break;
      case 'fr': mainValue = this.section_name_fr; break;
      case 'de': mainValue = this.section_name_de; break;
      default: mainValue = this.section_name;
    }
    if (!this.section_name || this.section_name.trim() === '') this.section_name = mainValue;
    if (!this.section_name_ca || this.section_name_ca.trim() === '') this.section_name_ca = mainValue;
    if (!this.section_name_en || this.section_name_en.trim() === '') this.section_name_en = mainValue;
    if (!this.section_name_it || this.section_name_it.trim() === '') this.section_name_it = mainValue;
    if (!this.section_name_fr || this.section_name_fr.trim() === '') this.section_name_fr = mainValue;
    if (!this.section_name_de || this.section_name_de.trim() === '') this.section_name_de = mainValue;
  }

  updateSection() {
    this.rellenarIdiomasVacios();
    this.show_alert = false;
    //Preparamos el objecto para insertarlo en los dish del menu
    var _obj = {};
    for (var i = 0; this.cartaServices.carta_dish_prod_array_tmp.length > i; i++) {

      _obj[i] = {
        uid: this.cartaServices.carta_dish_prod_array_tmp[i][0],
        order: i + 1,
        type: this.cartaServices.carta_dish_prod_array_tmp[i][2],
        name_es: this.cartaServices.carta_dish_prod_array_tmp[i][3],
        name_ca: this.cartaServices.carta_dish_prod_array_tmp[i][4],
        name_en: this.cartaServices.carta_dish_prod_array_tmp[i][5],
        name_de: this.cartaServices.carta_dish_prod_array_tmp[i][6],
        name_fr: this.cartaServices.carta_dish_prod_array_tmp[i][7],
        name_it: this.cartaServices.carta_dish_prod_array_tmp[i][8],
        allergens: this.cartaServices.carta_dish_prod_array_tmp[i][9] || [],
        price: this.cartaServices.carta_dish_prod_array_tmp[i][10],
        price_half: this.cartaServices.carta_dish_prod_array_tmp[i][11],
        price_tapa: this.cartaServices.carta_dish_prod_array_tmp[i][12],
        cost_ration: this.cartaServices.carta_dish_prod_array_tmp[i][13],
        image: this.cartaServices.carta_dish_prod_array_tmp[i][14],
        description_es: this.cartaServices.carta_dish_prod_array_tmp[i][15] || '',
        description_ca: this.cartaServices.carta_dish_prod_array_tmp[i][16] || '',
        description_en: this.cartaServices.carta_dish_prod_array_tmp[i][17] || '',
        description_de: this.cartaServices.carta_dish_prod_array_tmp[i][18] || '',
        description_fr: this.cartaServices.carta_dish_prod_array_tmp[i][19] || '',
        description_it: this.cartaServices.carta_dish_prod_array_tmp[i][20] || '',
        tags: this.cartaServices.carta_dish_prod_array_tmp[i][21] || [],
        price_takeaway: this.cartaServices.carta_dish_prod_array_tmp[i][22],
        tk_active: this.cartaServices.carta_dish_prod_array_tmp[i][23],
        featured: this.cartaServices.carta_dish_prod_array_tmp[i][24],
        tk_pickup_day: this.cartaServices.carta_dish_prod_array_tmp[i][25] || '',
        tax: this.cartaServices.carta_dish_prod_array_tmp[i][26],
      };
    }

    if (this.update_state) {
      if (this.new_section) {
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name = this.section_name;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_ca = this.section_name_ca;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_en = this.section_name_en;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_fr = this.section_name_fr;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_it = this.section_name_it;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].name_de = this.section_name_de;
        this.cartaServices.carta_tmp.pages[this.page_index].sections[this.section_index].elements = _obj;
      } else {
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name = this.section_name;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_ca = this.section_name_ca;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_en = this.section_name_en;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_fr = this.section_name_fr;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_it = this.section_name_it;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].name_de = this.section_name_de;
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index].elements = _obj;
      }
    } else {
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name = this.section_name;
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name_ca = this.section_name_ca || '';
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name_en = this.section_name_en || '';
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name_fr = this.section_name_fr || '';
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name_it = this.section_name_it || '';
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].name_de = this.section_name_de || '';
      this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index].elements = _obj;
    }
    this.cartaServices.carta_dish_prod_array_tmp = Array(); //Limpiamos el array
  }

  init_carta_dish_prod_array_tmp() {
    if (!this.update_state) { //
      var _obj: any;
      if (this.section_index == 0) {
        //Creamos array tmp
        _obj = {
          0: {
            name: this.section_name,
            name_ca: this.section_name_ca,
            name_en: this.section_name_en,
            name_it: this.section_name_it,
            name_fr: this.section_name_fr,
            name_de: this.section_name_de,
            order: this.section_index + 1,
            elements: this.cartaServices.carta_dish_prod_array_tmp,
          },
        };
        this.cartaServices.carta_section_array_complete_tmp = _obj;

      } else {
        //Si no es la primera seccion creamos solo la nueva seccion
        this.cartaServices.carta_section_array_complete_tmp[this.section_index] = {
          name: this.section_name,
          name_ca: this.section_name_ca,
          name_en: this.section_name_en,
          name_it: this.section_name_it,
          name_fr: this.section_name_fr,
          name_de: this.section_name_de,
          order: this.section_index + 1,
          elements: this.cartaServices.carta_dish_prod_array_tmp,
        };
      }

      if (this.page_index == 0) {
        var _page = {
          0: {
            number: 1,
            sections: this.cartaServices.carta_section_array_complete_tmp,
          },
        };
        this.cartaServices.carta_page_array_complete_tmp = _page;
      } else {
        this.cartaServices.carta_page_array_complete_tmp[this.page_index] = {
          number: 1,
          sections: this.cartaServices.carta_section_array_complete_tmp,
        };
      }

    } else {
      if (this.new_section) {
        this.cartaServices.carta_page_array_complete_tmp = this.cartaServices.carta_tmp.pages;

        this.cartaServices.carta_page_array_complete_tmp[this.page_index].sections[this.section_index] = {
          name: this.section_name,
          name_ca: this.section_name_ca,
          name_en: this.section_name_en,
          name_it: this.section_name_it,
          name_fr: this.section_name_fr,
          name_de: this.section_name_de,
          order: this.section_index + 1,
          elements: {},
        };

      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/carta/carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select.ts